module.exports = __webpack_public_path__ + "web/img/level-3.a603f25d.png";